<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 수행평가 대상</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>부서(업체)명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            :fieldId="form.stdInfo.field_id"
            v-model="form.inputA_1"
            placeholder="선택"
            @select="targetCompany">
          </CompanySelector>
        </div>
        <div>
          <div>피평가자</div>
          <ml-input v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_3" />
        </div>
      </div>
    </div>

    <vs-row class="mt-6 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 구분</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.checked === '상반기'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
          상반기
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :checked="form.checked === '상반기'"
          @change="checkForm($event, '상반기')"
        >상반기</vs-checkbox>
      </div>

      <div class="col-span-4 flex items-center">
        <template v-if="isPrint">
          <div class="item-box-check" v-if="form.checked === '하반기'" style="text-align: center;  align-self: center;">
            <vs-icon icon="check" size="small"  ></vs-icon>
          </div>
          <div v-else class="item-box-check">
          </div>
          하반기
        </template>
        <vs-checkbox
          v-else
          class="item-box-check"
          :checked="form.checked === '하반기'"
          @change="checkForm($event, '하반기')"
        >하반기</vs-checkbox>
      </div>
    </div>

    <table-score
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-note="false"
      :is-not-dot-in-label="true"
      :title="'업무 수행 여부'"
      :list="form.scoreList"
      table-header-label="평가항목"
      table-header-content="평가기준"
      table-header-score="배점"
      @update-list-check="updateListCheck"
      @update-value="updateValue"
    />

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="점검 현장 사진"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import TableScore from "@/components/TableScore.vue";

export default {
  components: {
    TableScore,
    PhotoUploadGridModule,
    CompanySelector,
    DateSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        companyName: "",
        photoList: [],
        checked: "",

        inputA_1: '',
        inputA_2: '',
        inputA_3: '',

        score: 0,
        scoreList: [
          {
            id: 1,
            title: '1. 기계･기구 또는 설비의 안전･보건점검 및 이상유무의 확인(20점)',
            label: '1) 기계･기구 또는 설비의 점검',
            content: '법 제80조 기계기구 및 설비의 안전보건점검 실시',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 2,
            title: '1. 기계･기구 또는 설비의 안전･보건점검 및 이상유무의 확인(20점)',
            label: '2) 유해·위험 방지 점검 실시',
            content: '유해･위험 방지 업무에 있어서의 점검 및 조치',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },
          {
            id: 3,
            title: '1. 기계･기구 또는 설비의 안전･보건점검 및 이상유무의 확인(20점)',
            label: '3) 작업 시작 전 점검사항',
            content: '작업 시작 전 점검실시',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },
          {
            id: 4,
            title: '1. 기계･기구 또는 설비의 안전･보건점검 및 이상유무의 확인(20점)',
            label: '4) 안전･보건조치',
            content: '안전보건기준에 관한 규칙에 관리감독자가 직무',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },

          {
            id: 5,
            title: '2. 근로자의 작업복･보호구 및 방호장치의 점검과 그 착용･사용에 관한 교육･지도(15점)',
            label: '1) 작업복의 착용 등',
            content: '작업복의 점검과 착용에 관한 교육･지도',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 6,
            title: '2. 근로자의 작업복･보호구 및 방호장치의 점검과 그 착용･사용에 관한 교육･지도(15점)',
            label: '2) 보호구의 착용･사용 등',
            content: '보호구의 점검과 착용･사용에 관한 교육･지도',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },
          {
            id: 7,
            title: '2. 근로자의 작업복･보호구 및 방호장치의 점검과 그 착용･사용에 관한 교육･지도(15점)',
            label: '3) 방호장치의 점검과 사용',
            content: '방호장치의 점검과 사용에 관한 교육･지도',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },

          {
            id: 8,
            title: '3. 산업재해에 관한 보고 및 응급조치(10점)',
            label: '1) 산업재해에 관한 발생 보고',
            content: '산업재해에 관한 발생 보고 및 기록 등',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 9,
            title: '3. 산업재해에 관한 보고 및 응급조치(10점)',
            label: '2) 응급조치',
            content: '산업안전보건법 및 안전보건규칙에 따른 응급조치',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },

          {
            id: 10,
            title: '4. 작업장 정리･정돈 및 통로확보에 대한 확인･감독(10점)',
            label: '1) 작업장 정리･정돈',
            content: '작업장 정리･정돈에 대한 확인･감독',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 11,
            title: '4. 작업장 정리･정돈 및 통로확보에 대한 확인･감독(10점)',
            label: '2) 통로 확보',
            content: '통로 확보에 대한 확인･감독',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },

          {
            id: 12,
            title: '5. 안전관리자, 보건관리자, 안전보건관리담당자, 산업보건의 지도･조언에 대한 협조(5점)',
            label: '1) 관리감독자의 성실 의무',
            content: '건강진단 실시계획 수립',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },

          {
            id: 13,
            title: '6. 위험성평가의 유해위험요인의 파악 및 그 결과에 따른 개선조치(20점)',
            label: '1) 유해위험요인 파악',
            content: '사업장 내 유해위험요인 파악',
            score: 10,
            good: 10,
            normal: 5,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 14,
            title: '6. 위험성평가의 유해위험요인의 파악 및 그 결과에 따른 개선조치(20점)',
            label: '2) 감소대책 수립 및 실행',
            content: '위험성 감소대책 수립 및 실행',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },
          {
            id: 15,
            title: '6. 위험성평가의 유해위험요인의 파악 및 그 결과에 따른 개선조치(20점)',
            label: '3) 기록 및 보존',
            content: '위험성평가 실시내용 및 결과의 기록보존',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },

          {
            id: 16,
            title: '7. 안전보건 활동의지 및 안전보건 역량(10점)',
            label: '1) 업무수행의 의지',
            content: '안전보건 활동의지(수행 의지, 열정, 사명감 등)',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 17,
            title: '7. 안전보건 활동의지 및 안전보건 역량(10점)',
            label: '2) 역량의 적격성',
            content: '안전보건관리에 대한 역량',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },

          {
            id: 18,
            title: '8. 안전보건 추진계획에 따른 예산편성 및 집행(10점)',
            label: '1) 예산 편성의 적정성',
            content: '안전보건 추진과제별 소요예산의 편성 및 확보',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
            titleColor: '#f9f9f9',
          },
          {
            id: 19,
            title: '8. 안전보건 추진계획에 따른 예산편성 및 집행(10점)',
            label: '2) 예산 집행의 적정성',
            content: '예산 집행 계획 및 집행 내역의 적정성',
            score: 5,
            good: 5,
            normal: 3,
            bad: 1,
            note: '',
            is_checked: '',
          },
        ],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
    updateListCheck (indexList, text) {
      this.form.scoreList[indexList].is_checked = text
    },
    updateValue (value) {
      this.form.score = value
    },
    checkForm (value, text) {
      this.form.checked = text
    }
  },
};
</script>

<style scoped lang="scss">
</style>
